import React, { useState } from "react";
import PropTypes from "prop-types";

import { Title, Fieldset, Field, Control, Button } from "rbx";
import { useMutation } from "react-apollo";
import { ConfirmPasswordInput } from "../inputs";

import { UPDATE_USER_MUTATION } from "../../graphql/Users/Users.graphql";

import { ourToast as toast } from "../../utils";

const INITIAL_STATE = {
  UserId: "",
  Password: "",
  FirstName: "",
  MiddleName: "",
  LastName: "",
  Active: true,
  CompanyId: localStorage.getItem("user_company") || ""
};
const ChangePasswordForm = ({ user, onComplete }) => {
  const [inputs, setInputs] = useState({
    ...INITIAL_STATE,
    ...user,
    ConfirmPassword: ""
  });
  const [updateUser, { loading }] = useMutation(UPDATE_USER_MUTATION, {
    refetchQueries: ["ALL_USERS_QUERY", "SINGLE_USER_QUERY"]
  });

  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setInputs({ ...inputs, [e.target.name]: value });
  };
  return (
    <form
      id={`change-password-user-form-${user.RecId}`}
      onSubmit={async e => {
        e.preventDefault();
        const obj = Object.keys(INITIAL_STATE).reduce(
          (acc, curr) =>
            inputs[curr] !== null ? { ...acc, [curr]: inputs[curr] } : acc,
          {}
        );
        try {
          if (obj.Password !== inputs.ConfirmPassword) {
            throw new Error("Passwords must match. Try again.");
          }
          await updateUser({
            variables: {
              data: { ...obj },
              where: { RecId: parseInt(user.RecId) }
            }
          });
          onComplete();
          toast.success("Password changed successfully.");
        } catch (err) {
          toast.error("Error changing Password.");
        }
      }}
    >
      <Title size={4}>Change Password</Title>
      <Fieldset disabled={loading}>
        <input id="userid" name="UserId" type="hidden" value={user.UserId} />
        <Field>
          <Control>
            <ConfirmPasswordInput
              required
              password={inputs.Password}
              onChange={handleChange}
            />
          </Control>
        </Field>
        <hr />
        <Field kind="group">
          <Control>
            <Button
              color="primary"
              form={`change-password-user-form-${user.RecId}`}
              type="submit"
            >
              Submit
            </Button>
          </Control>
          <Control>
            <Button type="button" onClick={onComplete}>
              Cancel
            </Button>
          </Control>
        </Field>
      </Fieldset>
    </form>
  );
};
ChangePasswordForm.propTypes = {
  onComplete: PropTypes.func,
  user: PropTypes.object
};
export default ChangePasswordForm;
